require('./dirPagination');
module.exports = 'angularUtils.directives.dirPagination';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-utils-pagination/index.js
 ** module id = 904
 ** module chunks = 8
 **/